import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ExerciseFromDbComponent } from './exercise-from-db.component';
import { Auth, authState } from '@angular/fire/auth';
import { firstValueFrom } from 'rxjs';
import { DbExercise } from 'src/models/db-exercises.model';
import { Exercise } from 'src/models/exercise.model';
import { ExerciseService } from 'src/services/exercise-service.service';
import { MuscleGroupService } from 'src/services/muscle-group.service';

@Injectable({
  providedIn: 'root', // This makes the service a singleton and available application-wide
})
export class ExerciseFromDbController {
  constructor(
    private modalController: ModalController,
    private muscleGroupService: MuscleGroupService,
    private exerciseService: ExerciseService,
    private auth: Auth
  ) {}

  async presentModal() {
    const modal = await this.modalController.create({
      component: ExerciseFromDbComponent,
    });

    return await modal.present();
  }

  async addExercise(dbExercise: DbExercise): Promise<string> {
    const user = await firstValueFrom(authState(this.auth));
    if (!user) throw new Error('No user authenticated');

    // Check if dbExercise.id is not null and an exercise with the same dbExercise.id already exists
    if (dbExercise.id) {
      const existingExercise =
        await this.exerciseService.getExerciseByDbExerciseId(
          user.uid,
          dbExercise.id
        );
      if (existingExercise) {
        console.log('Existing exercise ID returned');
        return existingExercise.id; // Return the ID of the existing exercise
      }
    }

    const exercise: Exercise = {
      userId: user.uid,
      sportName: dbExercise.name,
      description: '',
      hashtags: this.muscleGroupService.getDbExerciseArrayMuscleGroup(
        dbExercise.primaryMuscles
      ), // Adding selected muscle groups as hashtags
      secondaryHashtags: this.muscleGroupService.getDbExerciseArrayMuscleGroup(
        dbExercise.secondaryMuscles
      ),
      imageUrl: '',
      dbExerciseId: dbExercise.id,
    };

    const docRef = await this.exerciseService.addExercise(exercise);

    console.log('New exercise added successfully');

    // You might want to handle form reset or user feedback here

    return docRef.id; // Return the ID of the newly added exercise
  }
}
